<ng-container *ngIf="position && position.length >= 3">
    <div class="flex-row">
        <label for="x-position" class="number-input-label">x</label>
        <input
            class="number-input-no-arrow"
            id="x-position"
            placeholder="x position"
            type="number"
            (blur)="onCoordinateChanged(0, $event)"
            [value]="position[0].toFixed(1)"
            (paste)="handleDropEvent($event)"
            (keyup)="onEnter($event)"
        />
        <label for="y-position" class="number-input-label">y</label>
        <input
            class="number-input-no-arrow"
            id="y-position"
            placeholder="y position"
            type="number"
            (blur)="onCoordinateChanged(1, $event)"
            [value]="position[1].toFixed(1)"
            (paste)="handleDropEvent($event)"
            (keyup)="onEnter($event)"
        />
        <label for="z-position" class="number-input-label">z</label>
        <input
            class="number-input-no-arrow"
            id="z-position"
            placeholder="z position"
            type="number"
            (blur)="onCoordinateChanged(2, $event)"
            [value]="(position[2] - 0.5).toFixed(1)"
            (paste)="handleDropEvent($event)"
            (keyup)="onEnter($event)"
        />
        <cds-button
            [cdkCopyToClipboard]="copyValues()"
            title="Copy to clipboard"
            size="sm"
            action="flat"
        >
            <cds-icon shape="copy-to-clipboard"></cds-icon>
        </cds-button>
        <cds-button size="sm" action="flat" (click)="center()">Center</cds-button>
    </div>
</ng-container>
